import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom'; // Use NavLink here
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/mobileMenu.js";
import LanguageSelector from '../cozy/LanguageSelector';

function MobileMenu() {
    useEffect(() => {
        // Delay initialization to ensure DOM is ready
        const initMobileMenu = () => {
            const hmBtn = document.getElementById("mb-sidebar-btn");

            if (hmBtn) {
                const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
                const mdSidebarBody = document.getElementById("mb-sidebar-body");
                const mdSidebarExit = document.getElementById("close-mb-sidebar");

                const openMobileMenu = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (mdSidebarOverlay && mdSidebarBody) {
                        mdSidebarOverlay.classList.add("visible");
                        mdSidebarBody.classList.add("opened");
                    }
                };

                const closeMobileMenu = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (mdSidebarOverlay && mdSidebarBody) {
                        mdSidebarOverlay.classList.remove("visible");
                        mdSidebarBody.classList.remove("opened");
                    }
                };

                // Remove existing listeners first (in case of re-initialization)
                hmBtn.removeEventListener("click", openMobileMenu);
                hmBtn.removeEventListener("touchstart", openMobileMenu);

                hmBtn.addEventListener("click", openMobileMenu);
                hmBtn.addEventListener("touchstart", openMobileMenu, { passive: false });

                if (mdSidebarOverlay) {
                    mdSidebarOverlay.removeEventListener("click", closeMobileMenu);
                    mdSidebarOverlay.removeEventListener("touchstart", closeMobileMenu);
                    mdSidebarOverlay.addEventListener("click", closeMobileMenu);
                    mdSidebarOverlay.addEventListener("touchstart", closeMobileMenu, { passive: false });
                }

                if (mdSidebarExit) {
                    mdSidebarExit.removeEventListener("click", closeMobileMenu);
                    mdSidebarExit.removeEventListener("touchstart", closeMobileMenu);
                    mdSidebarExit.addEventListener("click", closeMobileMenu);
                    mdSidebarExit.addEventListener("touchstart", closeMobileMenu, { passive: false });
                }

                return { openMobileMenu, closeMobileMenu, hmBtn, mdSidebarOverlay, mdSidebarExit };
            }
            return null;
        };

        let handlers = initMobileMenu();

        const timeoutId = setTimeout(() => {
            if (!handlers) {
                handlers = initMobileMenu();
            }
        }, 100);

        // Cleanup function
        return () => {
            clearTimeout(timeoutId);
            if (handlers) {
                const { openMobileMenu, closeMobileMenu, hmBtn, mdSidebarOverlay, mdSidebarExit } = handlers;
                if (hmBtn) {
                    hmBtn.removeEventListener("click", openMobileMenu);
                    hmBtn.removeEventListener("touchstart", openMobileMenu);
                }
                if (mdSidebarOverlay) {
                    mdSidebarOverlay.removeEventListener("click", closeMobileMenu);
                    mdSidebarOverlay.removeEventListener("touchstart", closeMobileMenu);
                }
                if (mdSidebarExit) {
                    mdSidebarExit.removeEventListener("click", closeMobileMenu);
                    mdSidebarExit.removeEventListener("touchstart", closeMobileMenu);
                }
            }
        };
    });

    return (
        <Styles>
            {/* Mobile Menu */}
            <section className="mobile-menu-area">
                <Container>
                    <Row>
                        <Col md="0" sm="12">
                            <div className="mb-logo-area d-flex justify-content-between">
                                <div className="mb-logo-box d-flex">
                                    <div className="hm-button">
                                        <a href={process.env.PUBLIC_URL + "/"} id="mb-sidebar-btn">
                                            <i className="las la-bars"></i>
                                        </a>
                                    </div>
                                    <div className="mb-logo">
                                        <NavLink to={process.env.PUBLIC_URL + "/"}>
                                            <img src={process.env.PUBLIC_URL + "/assets/images/cozy_logo_3c.png"} alt="" />
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Mobile Menu Sidebar */}
            <section className="mb-sidebar" id="mb-sidebar-body">
                <div className="mb-sidebar-heading d-flex justify-content-between align-items-center">
                    <div><h5>Menu</h5></div>
                    <div>
                        <LanguageSelector />
                    </div>
                    <div><a href={process.env.PUBLIC_URL + "/"} id="close-mb-sidebar"><i className="las la-times"></i></a></div>
                </div>
                <div className="mb-sidebar-menu">
                    <div className="mb-menu-item">
                        <div className="mb-menu-content show">
                            <ul className="list-unstyled">
                                <li>
                                    <NavLink exact activeClassName="active" to={process.env.PUBLIC_URL + "/"}>Home</NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to={process.env.PUBLIC_URL + "/about"}>About</NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link"
                                        to={process.env.PUBLIC_URL + "/product-category"}
                                        isActive={(match, location) => {
                                            return location.pathname.includes("product");
                                        }}
                                    >
                                        Products
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to={process.env.PUBLIC_URL + "/services"}>Services</NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to={process.env.PUBLIC_URL + "/clients"}>Clients</NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to={process.env.PUBLIC_URL + "/contact"}>Contact</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div className="mb-sidebar-overlay" id="mb-sidebar-overlay"></div>
        </Styles>
    )
}

export default MobileMenu;
